<template>
  <div class="white-box mt-3" :class="{ 'no-min-height': noMinHeight }">
    <div v-if="showHeader" class="header-toolbar gap-2">
      <div class="left-side" style="flex: 1;">
        <div class="row align-items-center mm15">
          <div class="d-flex justify-content-center align-items-center gap-2 col-12 col-xl-3">
            <div class="grey"> Entries</div>
            <select class="form-select" aria-label="Default select" :value="perpage"
              @change="$emit('update:perpage', $event.target.value)">
              <option v-for="(item, i) in listEntries" :key="i" :value="item.value">{{ item.label }}</option>
            </select>
          </div>
          <div v-permissions="formattedPermissions.create" class="col-12 col-xl-3">
            <a @click.prevent="$router.push({ path: `${relativePath}/add` })" href="#" class="btn btn-orange w-100">Add
              New</a>
          </div>
          <div v-if="downloadable" class="col-12 col-xl-3">
            <a @click.prevent="onDownload" href="#"
              class=" btn-border-orange-no-hover w-100 d-flex align-items-center justify-content-center flex-row gap-2">
              <img src="@/assets/icons/file.svg" alt="file">
              <span>Download</span>
            </a>
          </div>
        </div>
      </div>
      <div class="right-side">
        <div class="row justify-content-end">
          <div class="col-xl-6 col-12">
            <input type="text" @input="debounceSearch" :value="search" class="form-control mm15" placeholder="Search">
          </div>
          <div v-if="$slots.filter" class="col-xl-5 col-12">
            <button @click.prevent="modal.filter = true" class="btn btn-filter" type="button">Filter by</button>
            <div class="overlay" :class="{ 'overlayshow': modal.filter }"></div>

            <!--Popup-->
            <div id="filter-content" class="popup-wrapper" :class="{ 'showing': modal.filter }">
              <div class="popup-card">
                <form ref="formFilter" @submit.prevent="onApplyFilter">
                  <div class="d-flex justify-content-between align-items-center mb15">
                    <div class="font-bold">Filter</div>
                    <button type="button" @click="modal.filter = false" class="btn btn-for-close"><span
                        class="icon-ico-close"></span></button>
                  </div>
                  <slot name="filter"></slot>
                  <slot name="filter-action">
                    <div class="d-flex justify-content-center">
                      <button @click="$emit('reset-filter')" class="btn btn-border-red mx-2"
                        type="button">Reset</button>
                      <button class="btn btn-orange mx-2" type="submit">Apply</button>
                    </div>
                  </slot>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table" style="white-space: nowrap">
        <thead>
          <tr>
            <th v-for="field in tableFields" :key="`th-${field.key}`" :class="field?.class">{{ field?.label }}</th>
          </tr>
        </thead>
        <template v-if="rows.length > 0">
          <slot name="table-body">
            <tbody>
              <tr v-for="(row, index) in rows" :key="row.id">
                <td v-for="field in tableFields" :key="`td-${field.key}`">
                  <template v-if="field?.key == '_counter'">
                    {{ rowCounter(index) }}
                  </template>
                  <template v-else-if="field?.key == '_status'">
                    <div class="status"
                      :style="`background-color: ${statusBackground(row?.status)}1a;color: ${statusBackground(row?.status)};text-transform: Capitalize;`">
                      {{ row?.status }}
                    </div>
                  </template>
                  <template v-else-if="field?.key == '_actions'">
                    <div class="d-flex align-items-center">
                      <slot name="table-action(edit)" v-bind="row">
                        <router-link v-permissions="formattedPermissions.edit" :to="`${relativePath}/edit/${row?.id}`"
                          class="link-edit"><span class="icon-ico-pencil"></span></router-link>
                      </slot>
                      <slot name="table-action(view)" v-bind="row">
                        <router-link v-permissions="formattedPermissions.view"
                          :to="`${detailUrl ?? relativePath}/${row?.id}`" class="btn btn-see rbm"><span
                            class="icon-ico-eye"></span></router-link>
                      </slot>
                    </div>
                  </template>
                  <template v-else>
                    <slot :name="`cell(${field?.key})`" v-bind="row">
                      {{ row[field.key] }}
                    </slot>
                  </template>
                </td>
              </tr>
            </tbody>
          </slot>
        </template>
        <tbody v-else>
          <tr>
            <td colspan="7" class="text-center">No data found</td>
          </tr>
        </tbody>
      </table>
    </div>

    <pagination :total="total" :current="currentPage" @setCurrentPage="val => $emit('update:currentPage', val)" />
  </div>
</template>

<script>
import { Pagination } from '@/components';
import { downloadFile } from '@/utils/fetch'

export default {
  components: { Pagination },
  props: {
    perpage: {
      type: [Number, String],
      required: true
    },
    currentPage: {
      type: [Number, String],
      required: true
    },
    total: Number,
    search: String,
    rows: {
      type: Array,
      default: () => []
    },
    tableFields: {
      type: Array,
      required: true
    },
    downloadable: {
      type: Boolean,
      default: false
    },
    path: String,
    listEntries: {
      type: Array,
      default: () => [
        {
          label: '10',
          value: 10
        },
        {
          label: '20',
          value: 20
        },
        {
          label: '40',
          value: 40
        },
        {
          label: '100',
          value: 100
        },
      ],
    },
    downloadUrl: {
      type: String,
      default: null
    },
    detailUrl: {
      type: String,
      default: null
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    noMinHeight: {
      type: Boolean,
      default: false
    },
    permissions: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      debounce: null,
      modal: {
        filter: false
      }
    }
  },
  methods: {
    rowCounter(index) {
      return (this.currentPage - 1) * this.perpage + index + 1
    },
    statusBackground(status) {
      return status === 'active' ? '#28A745' : '#DC3545'
    },
    debounceSearch(event) {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.$emit("update:search", event.target.value)
      }, 600)
    },
    async onApplyFilter() {
      const isValid = await this.$validator.validate();
      if (isValid) {
        this.$emit('apply-filter')
        this.modal.filter = false
      }
    },
    async onDownload() {
      await downloadFile({
        path: this.downloadUrl,
        fileType: 'xlsx'
      })
    }
  },
  computed: {
    relativePath() {
      return this.path || this.$route.path
    },
    formattedPermissions() {
      const permissions = this.permissions.split(',')
      const format = action =>
        permissions.map(p => `${action} ${p}`).join(',')
      return {
        create: format('Create'),
        view: format('View'),
        edit: format('Edit')
      }
    }
  },
}
</script>

<style>
.no-min-height {
  min-height: unset !important;
}
</style>
